import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.parent = this.el.querySelector('.m-testimonials-videos_list');
        this.items = this.el.querySelectorAll('.m-testimonials-videos_item');

        this.items.forEach((item, index) => {
            item.addEventListener('mouseenter', () => {
                if (item.classList.contains('-first')) {
                    this.parent.classList.add('-to-right');
                }
                if (item.classList.contains('-last')) {
                    this.parent.classList.add('-to-left');
                }
            });

            item.addEventListener('mouseleave', () => {
                this.parent.classList.remove('-to-left');
                this.parent.classList.remove('-to-right');
            });
        });
    }
}
